export default {
  copyright: {
    id: 'merchant_home_page_footer-backmakert',
    defaultMessage: '© {date} Back Market',
  },
  termAndConditions: {
    id: 'merchant_home_page_footer-terms_and_conditions',
    defaultMessage: 'Tems and Conditions',
  },
  qualityCharter: {
    id: 'merchant_home_page_footer-quality_charter',
    defaultMessage: 'Quality Charter',
  },
  sellerSupportCenter: {
    id: 'merchant_home_page_footer-seller_support_center',
    defaultMessage: 'Seller Support Center',
  },
}
